import React from 'react';

import { Field } from 'redux-form';

import { HighQualityCandidateSettingsView } from '../settings/high-quality-candidate-settings-view';

import { JobField, JobFieldProps } from './job-field';

import { HighQualityCandidateForm } from '../details/util/hqc-settings/high-quality-candidate-form';

type InputProps = {
  jobId: number;
  jobDetails: JobDetails;
};

type Props = InputProps & JobFieldProps;

class JobFieldHighQualityCandidateSettingsComponent extends React.PureComponent<Props> {
  render() {
    const childrenProps = { ...this.props };
    return (
      <JobField
        {...childrenProps}
        title="Applicant Filters"
        caption="These options allow you to control which applicants show up in your to-do list."
        editView={
          <Field name="HqcSettings" component={HighQualityCandidateForm} jobId={this.props.jobId} />
        }
        displayView={<HighQualityCandidateSettingsView jobId={this.props.jobId} />}
      />
    );
  }
}

export const JobFieldHighQualityCandidateSettings = JobFieldHighQualityCandidateSettingsComponent;
